export default __webpack_public_path__ + "c4876b33031404bc5db03a3b90e02f29.png";